module.exports = __webpack_public_path__ + "static/media/TableReassignment.093b80bd.png";